import React from 'react';
import TraceTileContextProvider from '@/creditflowresearch/application/Trace/TraceTileContext';
import FiltersContextProvider from '@/creditflowresearch/application/FiltersContext';
import TraceTableContextProvider from '@/creditflowresearch/application/Trace/TraceTableContext';
import TraceAssetClassesContextProvider from '@/creditflowresearch/application/Trace/TraceAssetClassesContext';
import TraceFiltersContextProvider from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { defaultTileFilterPayload } from './constants';

const ComposeTraceTileContext = ({ children, traceTileData }) => {
  const {
    filterPayload,
  } = traceTileData;
  const { ...baseParams } = defaultTileFilterPayload;
  return (
    <TraceFiltersContextProvider>
      <TraceAssetClassesContextProvider>
        <TraceTileContextProvider
          filterPayload={ filterPayload }
        >
          <FiltersContextProvider initial={ { baseParams } }>
            <TraceTableContextProvider>
              { children }
            </TraceTableContextProvider>
          </FiltersContextProvider>
        </TraceTileContextProvider>
      </TraceAssetClassesContextProvider>
    </TraceFiltersContextProvider>
  );
};

export default ComposeTraceTileContext;
